import axios from "axios";
import mobiflix_router from "../../router/mobiflix";
import country_list from "../../locales/country_list.json";
import { stat } from "fs";
const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_Mobif");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}



//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //auth
  langButton_Mobif: ``,
  country_Mobif: parts[0],
  lang_Mobif: localStorage.getItem("lang_Mobif"),
  // lang_Mobif: brwlang,
  authentication_Mobif: "",
  IconHotpick_Mobif: require(`../../assets/games4all/imgs/other/Hot Picks.svg`),
  IconPopular_Mobif: require(`../../assets/games4all/imgs/other/Populars.svg`),
  homeSliderContentLoaded: false,
  //notification.vue
  notification_Mobif: {},
  HotPicksPage_Mobif: {},
  HotPicksPageLoad_Mobif: false,
  PopularPage_Mobif: {},
  subCate_Mobif: {},
  allData_Mobif: {},
  host_Mobif: host,
  gcid_Mobif: gcid,
  renew_date_Mobif: '',
  subscription_date_Mobif: '',
  msisdn_Mobif: '',
  country_name_Mobif: '',
  gateway_Mobif: '',
  is_unsub: '0',
  hpisLoad_Mobif: false,
  mobiflix_res_sub:''
};

const getters = {
  subCate_Mobif: state => state.subCate_Mobif,
  allData_Mobif: state => state.allData_Mobif,
  IconHotpick_Mobif: state => state.IconHotpick_Mobif,
  IconPopular_Mobif: state => state.IconPopular_Mobif,
  notification_Mobif: state => state.notification_Mobif,
  authentication_Mobif: state => state.authentication_Mobif,
  HotPicksPage_Mobif: state => state.HotPicksPage_Mobif,
  HotPicksPageLoad_Mobif: state => state.HotPicksPageLoad_Mobif,
  PopularPage_Mobif: state => state.PopularPage_Mobif,
  langButton_Mobif: state => state.langButton_Mobif,
  lang_Mobif: state => state.lang_Mobif,
  country_Mobif: state => state.country_Mobif,
  host_Mobif: state => state.host_Mobif,
  homeSliderContentLoaded: state => state.homeSliderContentLoaded,
  hpisLoad_Mobif: state => state.hpisLoad_Mobif,
  gcid_Mobif: state => state.gcid_Mobif,
  renew_date_Mobif: state => state.renew_date_Mobif,
  subscription_date_Mobif: state => state.subscription_date_Mobif,
  msisdn_Mobif: state => state.msisdn_Mobif,
  country_name_Mobif: state => state.country_name_Mobif,
  gateway_Mobif: state => state.gateway_Mobif,
  is_unsub_Mobif: state => state.is_unsub,
  mobiflix_res_sub: state => state.mobiflix_res_sub
};

const actions = {
  async fetchLang_Mobif({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchLangButton_Mobif({ commit }, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchPageHotPicks_Mobif({ commit }, file) {
    let data = file[0];

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(
        file[1].target.options[file[1].target.options.selectedIndex].value
      );
    } else {
      //default
      limit = 200;
    }

    state.HotPicksPageLoad_Mobif = false
    state.HotPicksPage_Mobif = {}
    
    let response = [];

    if(data == undefined){
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=${limit}&offset=0&domain=${host}`
      );
    }else{
      response = await axios.get(
        `${state.live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    let load = true
    response.data.data.sort((a, b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    );

    let hotpick = response.data.data
    commit("setPageHotPicks", {hotpick, load});
  },
  async fetchPagePopular_Mobif({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let url = `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=video&limit=${limit}&offset=0&domain=${host}`

    let response = await axios.get(url);

    let data = response.data.data;

    data.sort(function(a, b) {
      //to sort random
      return b.rating - a.rating;
    });

    commit("setPagePopular", data);
  },
  async getDomain_Mobif({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);
    let dom = response.data.data
    dom = dom.filter(item =>{
      return item.domain == host;
    })

    let domain = ""

    if(dom != ""){
      domain = dom[0].is_unsub;

      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{
      domain = '0'
    }
    
    commit("setUnsubButton", domain);
  },
  async fetchTokenID_Mobif({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userTokenID_Mobif");
    let userProfile = localStorage.getItem("userProfile_Mobif");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }

    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkTokenID_Mobif", auth);
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      mobiflix_router.push({ name: "Login" }).catch(err => {});
    }

    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        if(data.code == 'mobif80'){
          localStorage.setItem("userTokenID_Mobif", data.code);
          commit("setAuth", "guest");
        }else{
          localStorage.setItem("userTokenID_Mobif", data.code);
          commit("setUserProfile", JSON.parse(userProfile));
          commit("setAuth", "loggedin");
        }
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        if(data.code == 'mobif80'){
          localStorage.setItem("userTokenID_Mobif", data.code);
          commit("setAuth", "guest");
          mobiflix_router.push({ path: path }).catch(err => {});
        } else{
          let responses = await axios.post(
            `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
          );
          var response = JSON.parse(responses.data.contents);
          if (response.status == "active") {
            localStorage.setItem("userTokenID_Mobif", data.code);
            localStorage.setItem("userProfile_Mobif", responses.data.contents)
            commit("setUserProfile", response);
            commit("setAuth", "loggedin");
            mobiflix_router.push({ path: path }).catch(err => {});
            // location.reload();
          } else if (response.status == "inactive") {
            if (data.code != undefined) {
              alert(response.status.toUpperCase());
            }
            mobiflix_router.push({ name: "Login" }).catch(err => {});
          }
        }
      }
    } else {
      //if check is false
      mobiflix_router.push({ name: "Login" }).catch(err => {});
    }
  },
  async checkTokenID_Mobif({ commit }, auth) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subscribeContent_Mobif({ commit }, file) {
    let token = localStorage.getItem("userTokenID_Mobif");
    let lang = localStorage.getItem("lang_Mobif");
    let alert_pop = "";
    let alert_lang = require(`../../locales/mobiflix/${lang}.json`);
    
    alert_pop = alert_lang.not_subs;
    console.log(file)
    if(state.authentication_Mobif == 'guest'){
      commit("setAuth", "");
      localStorage.removeItem("userTokenID_Mobif");
      mobiflix_router.push({ name: "Login" }).catch(err => {});
    }else{ 
      if (token != null) {
        if (file[1] != "application/x-zip-compressed") {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_Mobif,
            product: 'mobiflix',
            content_id: file[2],
            type: "download"
          })
          window.location.href = file[0];
          // window.open(file[0], "download");
        } else {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_Mobif,
            product: 'mobiflix',
            content_id: file[2],
            type: "play"
          })

          window.open(file[0], "_blank");
        }
      } else {
        alert(alert_pop);

        setTimeout(() => {
          mobiflix_router.push({ name: "Login" }).catch(err => {});
        }, 1000);
      }
    }
  },
  async loginMobif({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_Mobif({ commit }) {
    let notify = [];
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if (w != 0) {
      date = date + 10;
    }

    let url = `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=&limit=10&offset=${date}&domain=${host}`;

    let res = await axios.get(url);

    let data = res.data.data.slice(0, 5);
    let noti = data.map(noti => {
      let sub_trans = JSON.parse(noti.subcategory_translate);

      if (sub_trans != null) {
        // console.log(noti.created_time)
        let trans_len = Object.keys(sub_trans).length;
        let trans_arr = Object.keys(sub_trans);

        noti.titleSub_english = noti.subcategory;
        if (sub_trans != null || sub_icon != null) {
          for (let i = 0; i < trans_len; i++) {
            noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
          }
        }
      }

      return noti;
    });

    if (w == 0) {
      //name ascending
      noti.sort((a, b) => a.cont_name_english.localeCompare(b.cont_name_english));
    } else {
      //name descending
      noti.sort((a, b) => b.cont_name_english.localeCompare(a.cont_name_english));
    }

    notify = noti.slice(0, 5);

    commit("setNotification", notify);
  },
  async logout_Mobif({commit}, is_unsub){
    $("#exampleModalCenter").modal("hide");
    if(is_unsub != '0'){
      let token = localStorage.getItem("userTokenID_Mobif");
      let lang = localStorage.getItem("lang_Mobif");
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_Mobif}/${state.gateway_Mobif}/unsub.php?code=${token}&msisdn=${state.msisdn_Mobif}`));
      removeStorage()
      var response = JSON.parse(responses.data.contents);
      
      if(responses.data.contents == 'success' || response.status =='success'){
        if (state.gateway_Mobif == 'mondiamedia') {
          mobiflix_router.push({ name: 'Unsubscription'}).catch(err => {});
        } else {
          mobiflix_router.push({ name: 'Login'}).catch(err => {});
        }
      }else if(response.status =='fail'){
        if (state.gateway_Mobif == 'mondiamedia' && state.gcid_Mobif =='339') {
          
          if(lang =='arabic'){
            state.mobiflix_res_sub = response.ar_error_message;
          }else{
            state.mobiflix_res_sub = response.en_error_message;
          }
         
          mobiflix_router.push({ name: 'Unsubscription'}).catch(err => {});
        }

      }else{
       
        mobiflix_router.push({ name: 'Login'}).catch(err => {});
      }
    }else{
      removeStorage();
      mobiflix_router.push({ name: 'Login'}).catch(err => {});
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_Mobif");
      localStorage.removeItem("userTokenID_Mobif");
      localStorage.removeItem("logged-in");
      commit("setAuth", "");
    }
  }
};

const mutations = {
  setNotification: (state, response) => (state.notification_Mobif = response),
  setAuth: (state, response) => (state.authentication_Mobif = response),
  setPageHotPicks: (state, response) => (
    state.HotPicksPage_Mobif = response.hotpick,
    state.HotPicksPageLoad_Mobif = response.load
  ),
  setPagePopular: (state, response) => (state.PopularPage_Mobif = response),
  setButton: (state, response) => (state.langButton_Mobif = response),
  setLanguage: (state, response) => (state.lang_Mobif = response),
  setUserProfile: (state, response) => (
    state.renew_date_Mobif = response.next_renew_date,
    state.subscription_date_Mobif = response.subscription_date,
    state.msisdn_Mobif = response.msisdn,
    state.country_name_Mobif = response.country_code,
    state.gateway_Mobif = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_Mobif = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
      
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/mobiflix-store.js